<template>
  <div>
    <p class="popular-event-title">Popular live events</p>

    <div class="tixstock-popular-categories-container">
      <div class="performer-card-list">
        <div v-for="item in visibleCategories" :key="item._id">
          <div class="tixstock-popular-category-card" @click="goToCategory(item)">
            <img
              :src="item.imageUrl"
              :alt="item.title"
              class="tixstock-popular-category-image"
            />
            <div class="tixstock-popular-card-content">
              <p class="tixstock-popular-category-title mb-0">
                {{ item.title }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- LOAD MORE / STATUS -->
      <div class="text-center mt-20">
        <!-- tixstock-popular-loader -->
        <div v-if="isLoading" class="mt-20">
          <div class="tixstock-popular-loader"></div>
        </div>

        <!-- Load More Button -->
        <div v-else-if="canLoadMore">
          <p class="f-14 mb-8">See more events</p>
          <img
            src="@/assets/images/tixstockcategories/icons/down-arrow.svg"
            alt="down arrow"
            class="mb-10 dropDownArrow"
            @click="loadMore"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      limit: 12,
      visibleCount: 12,
      isLoading: false,
    };
  },

  computed: {
    ...mapGetters(["popularCategories"]),

    visibleCategories() {
      return this.popularCategories.slice(0, this.visibleCount);
    },

    canLoadMore() {
      return this.visibleCount < this.popularCategories.length;
    },
  },

  methods: {
    goToCategory(category) {
      if (!category.slug) return;
      this.$router.push(`/international/event/${category._id}`);
    },
    loadMore() {
      this.isLoading = true;

      // Fake delay (API simulation)
      setTimeout(() => {
        this.visibleCount += this.limit;
        this.isLoading = false;
      }, 2000);
    },
  },
};
</script>

<style>
.tixstock-popular-category-card {
  transition: all 0.3s ease-out;
  border: 4px solid transparent;
  cursor: pointer;
  text-decoration: none;
  border-radius: 8px;
}
.tixstock-popular-category-card:hover {
  -webkit-box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.27);
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.27);
  -webkit-transform: scale(1.02) translateY(-8px);
  transform: scale(1.02) translateY(-8px);
  outline: 1px solid #000;
}
.tixstock-popular-category-image {
  position: relative;
  display: -ms-flexbox;
  display: flex;
  min-height: 100px;
  height: 100%;
  aspect-ratio: 16 / 9;
  object-fit: cover;
  transition: opacity 0.5s ease-out;
  width: 100%;
  opacity: 1;
  border-radius: 8px;
}
.performer-card-list {
  grid-template-columns: repeat(auto-fill, minmax(23%, 1fr));
  -webkit-column-gap: var(--bb-spacing-lg, 16px);
  -moz-column-gap: var(--bb-spacing-lg, 16px);
  column-gap: var(--bb-spacing-lg, 16px);
  row-gap: var(--bb-spacing-xl, 24px);
  margin-top: var(--bb-spacing-md, 8px);
  display: grid;
}
.tixstock-popular-card-content {
  padding: 8px 4px;
}
.tixstock-popular-category-title {
  font-size: 16px;
  font-weight: 600;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.load-more-btn {
  background: #55279e;
  color: #fff;
  border: none;
  padding: 10px 22px;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 600;
}
.load-more-btn:hover {
  opacity: 0.9;
}
.tixstock-popular-loader {
  margin: 5px auto 55px;
  width: 40px;
  height: 40px;
  background-color: var(--bb-color-neutral-dark, #2f343b);
  border-radius: 100%;
  -webkit-animation: sk-scaleout 1s ease-in-out infinite;
  animation: sk-scaleout 1s ease-in-out infinite;
}
.dropDownArrow {
  height: 40px;
  width: 40px;
  animation: bounce 1s infinite;
}
.dropDownArrow:hover {
  cursor: pointer;
  transform: scale(1.1);
}
.popular-event-title {
  font-size: 26px;
  font-weight: 700;
  line-height: 48px;
  margin-bottom: 0px;
}
@keyframes sk-scaleout {
  0% {
    transform: scale(0);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 0;
  }
}
@media (max-width: 769px) {
  .performer-card-list {
    row-gap: var(--bb-spacing-lg, 16px);
  }
}
@media (max-width: 600px) {
  .performer-card-list {
    -webkit-column-gap: 12px;
    -moz-column-gap: 12px;
    column-gap: 12px;
    grid-template-columns: repeat(auto-fill, minmax(30%, 1fr));
  }
}
@media (max-width: 375px) {
  .performer-card-list {
    grid-template-columns: repeat(auto-fill, minmax(40%, 1fr));
  }
}
</style>
